import { motion } from "framer-motion";

/**
 * Features Grid: a heading + optional intro paragraph + responsive card grid
 * (2 cols mobile → 4 cols desktop). Each item has a title and description.
 * Used for "Our Values", benefits, feature callouts, etc.
 */
export default function FeaturesGridBlock({ data }) {
  const { heading, intro, items = [] } = data || {};
  return (
    <section className="py-14 lg:py-20 bg-slate-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {heading && (
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 text-center mb-3">
            {heading}
          </h2>
        )}
        {intro && (
          <p className="text-base text-slate-500 leading-relaxed text-center max-w-2xl mx-auto mb-12">
            {intro}
          </p>
        )}
        {items.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
            {items.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06, duration: 0.4 }}
                className="bg-white border border-slate-200 rounded-lg p-5"
                data-testid={`features-grid-item-${i}`}
              >
                <h3 className="text-base font-semibold text-slate-900 mb-2">{item.title}</h3>
                {item.description && (
                  <p className="text-sm text-slate-500 leading-relaxed whitespace-pre-line">
                    {item.description}
                  </p>
                )}
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
